module.exports = __webpack_public_path__ + "img/ind_6.fcb19836.png";